import { useEffect, useState } from 'react'
import { getPublicCategories } from '../../redux/actions/categoriesAction'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import styles from './PublicMenu.module.css'
import { CategoriesType } from '../../redux/actions/types'
import PublicDishesCard from '../PublicDishesCard/PublicDishesCard'
import PublicOrder from '../PublicOrder/PublicOrder'
import { useSearchParams } from 'react-router-dom'

const PublicMenu = ({ handleNextTab }: { handleNextTab: () => void }) => {
  const { category } = useAppSelector((state) => state.categories)
  const [activeCategory, setActiveCategory] = useState<CategoriesType | null>(null)
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const companyId = searchParams.get('companyId')

  useEffect(() => {
    if (companyId) {
      dispatch(getPublicCategories({ companyId }))
    }
  }, [companyId])

  useEffect(() => {
    if (category) {
      setActiveCategory(category.category[0])
    }
  }, [category])

  return (
    <div className={styles.publicMenu}>
      <div className={styles.publicMenuCategories}>
        {category.category.map((item) => (
          <div
            key={item.id}
            className={`${styles.publicMenuCategory} ${
              activeCategory?.id === item.id ? styles.activeCategory : ''
            }`}
            onClick={() => setActiveCategory(item)}
          >
            {item.name}
          </div>
        ))}
      </div>
      <div className={styles.publicMenuProductsContainer}>
        <div className={styles.publicMenuProducts}>
          {activeCategory?.products?.map((item) => (
            <PublicDishesCard
              categoryType={activeCategory.type}
              categoryName={activeCategory.name}
              categoryId={activeCategory.id}
              id={item.id}
              key={item.id}
              name={item.name}
              price={Number(item.price)}
              weight={item.weight}
              images={item.images}
              description={item.description ?? ''}
              measurement={item.measurement}
            />
          ))}
        </div>
        <PublicOrder handleNextTab={handleNextTab} />
      </div>
    </div>
  )
}

export default PublicMenu
